import { Controller } from "@hotwired/stimulus"

// Controls select all/deselect all and search functionality for the configurable timesheet filter dialog
export default class extends Controller {
  static targets = [
    "siteCheckbox",
    "employeeCheckbox",
    "teamCheckbox",
    "tradeCheckbox",
    "siteItem",
    "employeeItem",
    "teamItem",
    "tradeItem",
    "subjectLabel",
  ]

  static activeSubjectClasses = ["bg-green-600", "text-white", "font-medium"]
  static inactiveSubjectClasses = ["bg-white", "text-gray-700", "hover:bg-gray-50"]

  // Move the green highlight to the clicked subject-type option immediately,
  // without waiting for the form to be submitted and re-rendered server-side.
  selectSubjectType() {
    if (!this.hasSubjectLabelTarget) return

    this.subjectLabelTargets.forEach((label) => {
      const radio = label.querySelector("input[type=radio]")
      const active = radio?.checked
      label.classList.remove(
        ...(active
          ? this.constructor.inactiveSubjectClasses
          : this.constructor.activeSubjectClasses),
      )
      label.classList.add(
        ...(active
          ? this.constructor.activeSubjectClasses
          : this.constructor.inactiveSubjectClasses),
      )
    })
  }

  selectAllSites(event) {
    event.preventDefault()
    this.siteCheckboxTargets.forEach((checkbox) => {
      checkbox.checked = true
    })
  }

  deselectAllSites(event) {
    event.preventDefault()
    this.siteCheckboxTargets.forEach((checkbox) => {
      checkbox.checked = false
    })
  }

  selectAllEmployees(event) {
    event.preventDefault()
    this.employeeCheckboxTargets.forEach((checkbox) => {
      checkbox.checked = true
    })
  }

  deselectAllEmployees(event) {
    event.preventDefault()
    this.employeeCheckboxTargets.forEach((checkbox) => {
      checkbox.checked = false
    })
  }

  selectAllTeams(event) {
    event.preventDefault()
    this.teamCheckboxTargets.forEach((checkbox) => {
      checkbox.checked = true
    })
  }

  deselectAllTeams(event) {
    event.preventDefault()
    this.teamCheckboxTargets.forEach((checkbox) => {
      checkbox.checked = false
    })
  }

  selectAllTrades(event) {
    event.preventDefault()
    this.tradeCheckboxTargets.forEach((checkbox) => {
      checkbox.checked = true
    })
  }

  deselectAllTrades(event) {
    event.preventDefault()
    this.tradeCheckboxTargets.forEach((checkbox) => {
      checkbox.checked = false
    })
  }

  searchSites(event) {
    this.#filterItems(event.target.value, this.siteItemTargets)
  }

  searchEmployees(event) {
    this.#filterItems(event.target.value, this.employeeItemTargets)
  }

  searchTeams(event) {
    this.#filterItems(event.target.value, this.teamItemTargets)
  }

  searchTrades(event) {
    this.#filterItems(event.target.value, this.tradeItemTargets)
  }

  #filterItems(rawQuery, items) {
    const query = rawQuery.toLowerCase().trim()
    items.forEach((item) => {
      const name = item.dataset.name.toLowerCase()
      item.classList.toggle("hidden", query && !name.includes(query))
    })
  }
}
